<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div class="row" style="margin-top: 20px;margin-bottom: 20px;">
                                <div class="col">
                                    <h4 class="mb-4">Memo Details</h4>
                                </div>
                                <div class="col">
                                    <h4>
                                        <button id="reconBtn" class="btn btn-primary" v-on:click="navigateMEMODashboard()">
                                            Memo
                                        </button>
                                    </h4>
                                </div>
                            </div>
                            <div class="panelDiv">
                                <div class="container">
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="container">
                                        <div class="row col-sm-12">
                                            <div class="col">
                                                <table id="user-table"
                                                       class="table table-striped display table-bordered"
                                                       cellspacing="0"
                                                       width="100%">
                                                    <thead>
                                                        <tr>
                                                            <th>Client Name</th>
                                                            <th>Sent By</th>
                                                            <th>Sent To</th>
                                                            <th>Sent On</th>
                                                            <th>Download Memo</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody></tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import MEMO1Service from '../../services/MEMOService/MEMO1.service.js';
    import CommonService from '../../services/SharedService/common.service.js'
    import { EnvironmentConfig } from '../../services/constants';
    import Algorithm from '../../services/Algorithm.js';
    import $ from 'jquery';
    export default {
        name: "MEMOAdmin",
        mixins: [MEMO1Service, CommonService, Algorithm],
        data: () => ({
            dataTable: null,
            memoTemplateDetails: [],
        }),
        computed: {
        },
        created() {
            localStorage.setItem("route", this.$route.name);
        },
        methods: {
            navigateMEMODashboard() {
                this.$router.push("/MEMO");
            }
        },
        mounted() {
            this.dataTable = $("#user-table").DataTable({
                pageLength: 50,
                scrollY: "300px",
                scrollX: "1000px",
                scrollCollapse: true,
                columnDefs: [
                    { width: '20%', targets: 0 }
                ],
                fixedColumns: true
            });
            if (localStorage.getItem('role') == 'user') {
                this.dataTable.column(1).visible(false);
            }
            var table = this.dataTable;
            this.GetMemoTemplate().then(response => {
                if (response) {
                    this.memoTemplateDetails = response.data;
                    this.memoTemplateDetails.forEach(memoTemplateItems => {
                        table.row
                            .add([memoTemplateItems.clientName, memoTemplateItems.userName, memoTemplateItems.recipientName, memoTemplateItems.date, '<a href="' + memoTemplateItems.filePath + '" target="_blank">Download</a>'])
                            .draw(false);
                    });
                }
            });
        }
    };
</script>
<style>
    .group {
        display: flex;
        flex: 1;
        justify-content: space-around;
    }

    #reconBtn {
        margin-right: 5px;
        width: 170px;
        float: right;
    }

    #btnNewMap {
        margin-right: -10px;
        width: 170px;
    }
    /* Ensure that the demo table scrolls */
    th, td {
        white-space: normal;
        word-break:break-all;
    }

    div.dataTables_wrapper {
        margin: 0 auto;
    }

    div.container {
        width: 100%;
    }
</style>